import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Activity, ArrowRight, HeartHandshake, Hospital, Leaf, MapPin, ShieldCheck } from "lucide-react";
import AnimatedText from "../components/AnimatedText";
import Navbar from "./Navbar";
import DashboardBar from "../components/DashboardBar";
import DailyQuoteCard from "../components/DailyQuoteCard";
import NearbyFoodsPreview from "../components/NearbyFoodsPreview";
import NearbyGymsPreview from "../components/NearbyGymsPreview";
import NearbyHospitalsPreview from "../components/NearbyHospitalsPreview";
import DashboardTips from "../components/DashboardTips";
import Footer from "../components/Footer";
import Chatbot from "../components/Chatbot";
import { useTranslation } from "react-i18next";
import wellnessHero from "../assets/wellness-community-hero.png";
import "../styles/HomePage.css";
import "../styles/HomeMobile.css";

export default function HomePage() {
  const [showDashboard, setShowDashboard] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    const refresh = () => {
      const loggedIn = localStorage.getItem("isLoggedIn") === "true";
      const hasProfile = !!localStorage.getItem("userHeight") || !!localStorage.getItem("userWeight") || !!localStorage.getItem("lastBMI");
      setShowDashboard(loggedIn || hasProfile);
    };
    refresh();
    window.addEventListener("auth-change", refresh);
    window.addEventListener("storage", refresh);
    window.addEventListener("profile-updated", refresh);
    return () => {
      window.removeEventListener("auth-change", refresh);
      window.removeEventListener("storage", refresh);
      window.removeEventListener("profile-updated", refresh);
    };
  }, []);

  return <>
    <Navbar />
    <div className="container page home-page">
      <div className="home-ambient home-ambient-one" aria-hidden="true" /><div className="home-ambient home-ambient-two" aria-hidden="true" />
      <section className="section hero-section"><div className="hero-glass"><div className="hero-content">
        <div className="hero-copy-column">
          <div className="hero-eyebrow"><span className="hero-eyebrow-dot" />{t("mvp.hero_eyebrow")}</div>
          <AnimatedText text="Health is Wealth" className="home-text" />
          <p className="hero-copy">{t("mvp.hero_intro")}</p>
          <div className="hero-actions"><Link to="/tool" className="zoom-button">Check my health <ArrowRight size={18} /></Link><a className="hero-text-link" href="#how-it-works">{t("mvp.see_how")} <ArrowRight size={17} /></a></div>
        </div>
        <div className="hero-photo-wrap"><img src={wellnessHero} alt={t("mvp.hero_alt")} /><div className="hero-photo-pill"><HeartHandshake size={18} /> {t("mvp.healthier_together")}</div></div>
      </div></div></section>

      <section className="trust-strip" aria-label={t("mvp.trust_label")}><span><ShieldCheck size={18} /> {t("mvp.private")}</span><span><Activity size={18} /> {t("mvp.simple_bmi")}</span><span><MapPin size={18} /> {t("mvp.nearby_places")}</span></section>

      <section className="story-section" id="how-it-works"><div className="section-kicker">{t("mvp.steps_kicker")}</div><h2>{t("mvp.steps_title")}</h2><p className="section-lead">{t("mvp.steps_intro")}</p><div className="steps-grid">
        <article className="story-card"><span>01</span><Activity /><h3>{t("mvp.step1_title")}</h3><p>{t("mvp.step1_text")}</p></article>
        <article className="story-card"><span>02</span><ShieldCheck /><h3>{t("mvp.step2_title")}</h3><p>{t("mvp.step2_text")}</p></article>
        <article className="story-card"><span>03</span><MapPin /><h3>{t("mvp.step3_title")}</h3><p>{t("mvp.step3_text")}</p></article>
      </div></section>

      <section className="care-section"><div className="care-message"><div className="section-kicker">{t("mvp.care_kicker")}</div><h2>{t("mvp.care_title")}</h2><p>{t("mvp.care_text")}</p><Link to="/wellness-guide" className="care-link">{t("mvp.explore_guide")} <ArrowRight size={18} /></Link></div><div className="care-orbit" aria-label={t("mvp.core_areas")}><div className="orbit-center"><HeartHandshake size={30} /><strong>{t("mvp.care")}</strong></div><div className="orbit-chip orbit-food"><Leaf size={19} /> {t("mvp.nourish")}</div><div className="orbit-chip orbit-move"><Activity size={19} /> {t("mvp.move")}</div><div className="orbit-chip orbit-care"><Hospital size={19} /> {t("mvp.prevent")}</div></div></section>

      {showDashboard && <div className="home-grid two-col"><div className="home-main"><div className="home-dashboard"><DashboardBar /><DashboardTips /></div></div><div className="home-side"><DailyQuoteCard /></div></div>}
    </div>
    {showDashboard && <section className="previews-grid"><NearbyFoodsPreview /><NearbyGymsPreview /><NearbyHospitalsPreview /></section>}
    <Footer /><Chatbot />
  </>;
}
